<template>
    <kgr-profile-part v-if="memberShortProfile.paymentInformation !== null">
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2
                        v-t="'Zahlungsinformationen'"
                        class="kgr-headline kgr-headline--h3"
                    ></h2>
                </div>
            </div>
        </template>

        <template #content>
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                <dt
                    v-t="'Offener Gesamtbetrag'"
                    class="kgr-definitionList__term"
                ></dt>
                <dd class="kgr-definitionList__definition">
                    <a
                        class="kgr-link"
                        :href="memberShortProfile.paymentInformation.linkToInvoices"
                    >
                        {{ formatOpenAmount }}
                    </a>
                </dd>
                <dt
                    v-t="'Standard-Zahlart'"
                    class="kgr-definitionList__term"
                ></dt>
                <dd class="kgr-definitionList__definition">
                    {{ translatedPaymentMethod }}
                </dd>
                <template v-if="memberShortProfile.paymentInformation.iban">
                    <dt
                        v-t="'IBAN'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.paymentInformation.iban }}
                    </dd>
                </template>
            </dl>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import Money from '../../../js/dto/Money';
import ProfilePart from '../../short-profile/ProfilePart.vue';

export default {
    name: 'KgrMemberPartPaymentInformation',
    components: {
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        formatOpenAmount() {
            const openAmount = Money.fromData(this.memberShortProfile.paymentInformation.openAmount);
            return `${openAmount.toLocalizedString()} ${openAmount.currency}`;
        },
        translatedPaymentMethod() {
            return this.$t(`club.paymentMethod.${this.memberShortProfile.paymentInformation.paymentMethod}`);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
